import { replace } from 'react-router-dom';
import { fetchNotifications } from '@/pages/Notifications/api/requests';

export const notificationsLoader = async () => {
  const token = localStorage.getItem('token');
  if (!token) {
    return replace('/auth', { status: 301 });
  }

  const notificationsResponse = await fetchNotifications(token);

  if (!notificationsResponse?.data.length) {
    return replace('/cabinet', { status: 301 });
  }

  return notificationsResponse;
};
